import React, { createContext, useContext, useState, useEffect } from 'react';

const CompareContext = createContext(null);

const MAX_COMPARE = 4;
const STORAGE_KEY = 'compare_centers';

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(compareList));
  }, [compareList]);

  const addToCompare = (center) => {
    if (compareList.length >= MAX_COMPARE) {
      return false;
    }
    if (compareList.find(c => c.center_id === center.center_id)) {
      return false;
    }
    setCompareList(prev => [...prev, {
      center_id: center.center_id,
      name: center.name,
      city: center.city,
      slug: center.slug
    }]);
    return true;
  };

  const removeFromCompare = (centerId) => {
    setCompareList(prev => prev.filter(c => c.center_id !== centerId));
  };

  const isInCompare = (centerId) => {
    return compareList.some(c => c.center_id === centerId);
  };

  const clearCompare = () => {
    setCompareList([]);
  };

  const toggleCompare = (center) => {
    if (isInCompare(center.center_id)) {
      removeFromCompare(center.center_id);
      return false;
    } else {
      return addToCompare(center);
    }
  };

  return (
    <CompareContext.Provider value={{
      compareList,
      addToCompare,
      removeFromCompare,
      isInCompare,
      clearCompare,
      toggleCompare,
      maxCompare: MAX_COMPARE,
      canAddMore: compareList.length < MAX_COMPARE
    }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
}
